import * as angular from "angular";

export class HouseService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/house";
        this.v2Root = "/v2/house";
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.v2Root + "/" + data.id, data);
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/" + data.id, data);
    }

    building(id): Promise<object> {
        return this.$http.get(this.v2Root + "/building/" + id);
    }

    deleteHouses(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/delete_houses", data);
    }

    editHouses(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_edit", data);
    }

    geocodingstats(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/geocodingstats", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.hid, data);
    }

    search(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/search", data);
    }

    locations(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/locations", data);
    }

    geocodeStats(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/geocodeStats", data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    createHotspot(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create_hotspot", data);
    }

    zipcodes(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/zipcodes", data);
    }

    precincts(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/precincts", data);
    }

    center(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/center", data);
    }

    delete_items(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/delete_list", data);
    }

    bulk_delete(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_delete", data);
    }

    bulk_delete_streets(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_delete_streets", data);
    }

    all(data: any): Promise<object> {
        let url =
            this.apiRoot +
            "/all/" +
            data.filters +
            "/" +
            data.pages +
            "/" +
            data.limit;
        return this.$http.get(url, data);
    }

    hotspots(data: any): Promise<object> {
        let url =
            this.apiRoot +
            "/hotspots/" +
            data.filters +
            "/" +
            data.pages +
            "/" +
            data.limit;
        return this.$http.get(url, data);
    }

    all_streets(data: any): Promise<object> {
        let url =
            this.apiRoot +
            "/streets/" +
            data.effort +
            "/" +
            data.filters +
            "/" +
            data.pages +
            "/" +
            data.limit;
        return this.$http.get(url, data);
    }

    count(): Promise<object> {
        return this.$http.get(this.apiRoot + "/count");
    }
}

angular.module("vcServices").service("HouseService", HouseService);
